import DialogArticle from '@/components/dialog-article';

export default function ImprintDialog() {
  return (
    <DialogArticle>
      <h1 className='h1'>Impressum</h1>
      <h3 className='h3'>rightmart Rechtsanwalts GmbH</h3>
      <p className='p'>
        <b className='b'>Hauptsitz</b>
        <br />
        Clara-Jaschke-Straße 1<br />
        28199 Bremen
        <br />
        <b className='b'>Tel:</b>{' '}
        <a className='a' href='tel:+4942133100310' data-wpel-link='internal' target='_self' rel='noopener'>
          +49 (0)421 / 33 100 311
        </a>
        <br />
        <b className='b'>Fax:</b>{' '}
        <a className='a' href='tel:+4942133100380' data-wpel-link='internal' target='_self' rel='noopener'>
          +49 (0)421 / 33 100 380
        </a>
        <br />
        <b className='b'>E-Mail:</b>{' '}
        <a className='a' href='mailto:info@rightmart.de'>
          info@rightmart.de
        </a>
      </p>
      <p className='p'>
        Die Rechtsanwälte der rightmart Rechtsanwaltsgesellschaft mbH sind daher weiterhin Mitglieder der
        Rechtsanwaltskammer Bremen, die weiterhin auch als Aufsichtsbehörde zuständig ist, soweit auf dieser Seite
        nichts anderes angegeben.
      </p>
      <p className='p'>
        <b className='b'>Geschäftsführer:</b> Dr. Philipp Hammerich · Jan Frederik Strasmann
      </p>
      <p className='p'>
        rightmart Rechtsanwalts GmbH ist der Rechtsform nach eine Gesellschaft mit beschränkter Haftung.
      </p>
      <p className='p'>
        <b className='b'>Handelsregister:</b> AG Bremen, HRB 31070
        <br />
        <b className='b'>USt.-ID-Nr.:</b> DE305 884 905
        <br />
        <b className='b'>zuständiges Finanzamt:</b> Finanzamt Bremen
      </p>
      <h3 className='h3'>
        Zuständige Aufsichtsbehörde / Zuständige Kammer der rightmart Rechtsanwaltsgesellschaft mbH
      </h3>
      <p className='p'>
        Hanseatische Rechtsanwaltskammer Bremen, Knochenhauerstraße 36, 28195 Bremen |{' '}
        <a
          className='a'
          href='https://www.rak-bremen.de/'
          data-wpel-link='external'
          target='_blank'
          rel='nofollow external noopener noreferrer'
        >
          www.rak-bremen.de
        </a>
      </p>
      <h3 className='h3'>
        Zuständige Aufsichtsbehörde / Zuständige Kammer unserer Rechtsanwälte (soweit nicht Rechtsanwaltskammer Bremen):
      </h3>
      <ul className='ul' style={{ marginBottom: 20 }}>
        <li className='li'>
          <b className='b'>Christian Bode</b>
          <br />
          Rechtsanwaltskammer Celle, Bahnhofstraße 5, 29221 Celle |{' '}
          <a
            className='a'
            href='https://www.rakcelle.de'
            data-wpel-link='external'
            target='_blank'
            rel='nofollow external noopener noreferrer'
          >
            www.rakcelle.de
          </a>
        </li>
        <li className='li'>
          <b className='b'>Gero Landzettel</b>
          <br />
          Rechtsanwaltskammer Celle, Bahnhofstraße 5, 29221 Celle |{' '}
          <a
            className='a'
            href='https://www.rakcelle.de'
            data-wpel-link='external'
            target='_blank'
            rel='nofollow external noopener noreferrer'
          >
            www.rakcelle.de
          </a>
        </li>
        <li className='li'>
          <b className='b'>
            Tina Mertins
            <br />
          </b>
          Rechtsanwaltskammer Oldenburg, Staugraben 5, 26122 Oldenburg |{' '}
          <a
            className='a'
            href='https://www.rak-oldenburg.de'
            data-wpel-link='external'
            target='_blank'
            rel='nofollow external noopener noreferrer'
          >
            www.rak-oldenburg.de
          </a>
        </li>
      </ul>
      <h3 className='h3'>Einschlägige Gesetze</h3>
      <ul className='ul' style={{ marginBottom: 20 }}>
        <li className='li'>BRAO – Bundesrechtsanwaltsordnung</li>
        <li className='li'>
          Anwaltliche Berufsordnung (
          <a
            className='a'
            href='https://www.brak.de/w/files/02_fuer_anwaelte/berufsrecht/bora-stand-01.07.15.pdf'
            rel='nofollow external noopener noreferrer'
            data-wpel-link='external'
            target='_blank'
          >
            pdf-Download
          </a>
          )
        </li>
        <li className='li'>
          Fachanwaltsordnung (
          <a
            className='a'
            href='https://www.brak.de/w/files/02_fuer_anwaelte/FAO_1.1.08_090615.pdf'
            rel='nofollow external noopener noreferrer'
            data-wpel-link='external'
            target='_blank'
          >
            pdf-Download
          </a>
          )
        </li>
        <li className='li'>
          Berufsregeln der Rechtsanwälte der Europäischen Gemeinschaft (CCBE) (
          <a
            className='a'
            href='https://www.brak.de/w/files/02_fuer_anwaelte/Berufsregeln_Mai%202006_090615.pdf'
            rel='nofollow external noopener noreferrer'
            data-wpel-link='external'
            target='_blank'
          >
            pdf-Download
          </a>
          )
        </li>
        <li className='li'>RVG – Rechtsanwaltsvergütungsgesetz</li>
        <li className='li'>
          Gesetz über die Tätigkeit europäischer Rechtsanwälte in Deutschland (EuRAG) v. 9. 3. 2000 (BGBl. I S. 182) (
          <a
            className='a'
            href='https://www.gesetze-im-internet.de/eurag/EuRAG.pdf'
            rel='nofollow external noopener noreferrer'
            data-wpel-link='external'
            target='_blank'
          >
            pdf-Download
          </a>
          )
        </li>
      </ul>
      <p className='p'>
        Die Regelungen können auch bei der Hanseatischen Rechtsanwaltskammer Bremen eingesehen werden.
      </p>
      <p className='p'>Für unsere Tätigkeit besteht eine Berufshaftpflichtversicherung bei der HDI Versicherung AG.</p>
      <p className='p'>
        HDI Versicherungs AG
        <br />
        HDI Platz 1 30659
        <br />
        Hannover
        <br />
        Tel.: (0511) 64 53 736
        <br />
        Fax: (0511) 64 53 298
        <br />
        Die Versicherungssumme beträgt 2.500.000 Euro.
      </p>
      <h3 className='h3'>Räumlicher Geltungsbereich (AVB WSR 558)</h3>
      <p className='p'>
        Räumlicher Geltungsbereich ist das gesamte EU-Gebiet und die Staaten des Abkommens über den Europäischen
        Wirtschaftsraum. Die Einzelheiten der Versicherung sind der Hanseatische Rechtsanwaltskammer Bremen im Rahmen
        der Vorschriften der Bundesrechtsanwaltsordnung bekannt gemacht.
      </p>
      <h3 className='h3'>Hinweis</h3>
      <p className='p'>
        Trotz sorgfältiger inhaltlicher Kontrolle übernehmen wir keine Haftung für die Inhalte externer Links. Für den
        Inhalt der verlinkten Seiten sind ausschließlich deren Betreiber verantwortlich.
      </p>
      <h3 className='h3'>Vermeidung von Interessenkonflikten</h3>
      <p className='p'>
        Die Wahrnehmung widerstreitender Interessen ist uns untersagt. Bitte haben Sie daher Verständnis dafür, dass wir
        vor Annahme eines Mandats zunächst prüfen müssen, ob ein Interessenkonflikt vorliegt.
      </p>
      <h3 className='h3'>
        Plattform der EU zur außergerichtlichen Online-Streitbeilegung, Online-Streitbeilegung gemäß Art. 14 Abs. 1
        Verordnung (EU) Nr. 524/2013
      </h3>
      <p className='p'>
        Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:{' '}
        <a
          className='a'
          href='http://ec.europa.eu/consumers/odr/'
          target='_blank'
          rel='noopener noreferrer nofollow external'
          data-wpel-link='external'
        >
          http://ec.europa.eu/consumers/odr/
        </a>
        .
      </p>
      <h3 className='h3'>Allgemeine Informationspflicht nach § 36 VSBG</h3>
      <p className='p'>
        Zuständige Verbraucherschlichtungsstelle: Für vermögensrechtliche Streitigkeiten aus dem Mandatsverhältnis ist
        die Schlichtungsstelle der Rechtsanwaltschaft, Rauchstraße 26, 10787 Berlin, www.s-d-r.org, zuständig. Wir sind
        grundsätzlich bereit, an Streitbeilegungsverfahren bei der Schlichtungsstelle der Rechtsanwaltschaft
        teilzunehmen.
      </p>
    </DialogArticle>
  );
}
